import axiosInstance from "./api_helper";


export const createPurchase = async (purchaseData) => {
  try {
    const response = await axiosInstance.post('/api/purchase-orders', {
      ...purchaseData,
      lines: purchaseData.lines.map(item => ({
        productId: item.id,
        userPrice: item.userPrice,
        quantity: item.quantity,
        price: item.price
      })),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const search = async (startDate, endDate, query) => {
  try {
    const response = await axiosInstance.get('/api/purchase-orders/search', {
      params: {
        startDate,
        endDate,
        query
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPurchases = async (page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/purchase-orders', {
      params: { page: page - 1, size }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPurchasesData = (dateRange) => axiosInstance.get(`/purchase-orders/dashboard?dateRange=${dateRange}`);

export const getPurchaseById = async (id) => {
  try {
    const response = await axiosInstance.get(`/purchase-orders/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelPurchase = async (id) => {
  try {
    const response = await axiosInstance.post(`/purchase-orders/${id}/cancel`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPurchasesByDateRange = async (startDate, endDate, page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/purchase-orders/search', {
      params: {
        startDate,
        endDate,
        page: page - 1,
        size
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalPurchasesToday =  async () => {
  return axiosInstance.get(`/purchase-orders/total-purchase-orders/today`);
};

export const getTotalPurchasesThisWeek = async () => {
  return axiosInstance.get(`/purchase-orders/total-purchase-orders/this-week`);
};

export const getTotalPurchasesThisMonth = async () => {
  return axiosInstance.get(`/purchase-orders/total-purchase-orders/this-month`);
};

export const getTotalPurchasesThisYear = async () => {
  return axiosInstance.get(`/purchase-orders/total-purchase-orders/this-year`);
};

export const getTotalPurchasesForDateRange = async (startDate, endDate) => {
  return axiosInstance.get(`/purchase-orders/total-purchase-orders`, {
      params: {
          startDate: startDate,
          endDate: endDate
      }
  });
};

export const generatePdf = async (invoiceDTO) => {
  const response = await axiosInstance.post(`/purchase-orders/report`, invoiceDTO, {
      responseType: 'arraybuffer',
      headers: {
          'Content-Type': 'application/json',
      },
  });
  return response.data;
};

export const filterLines = async (startDate, endDate, query) => {
  try {
    const response = await axiosInstance.get('/api/purchase-orders/lines', {
      params: {
        startDate,
        endDate,
        query
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};